import { useScrollReveal } from "@/hooks/useScrollReveal";
import { Check } from "lucide-react";

export default function OldVideos() {
  const { ref, isVisible } = useScrollReveal();

  const features = [
    {
      title: "Double the revenue",
      description: "Same content on your other platforms. New earning on MSN",
    },
    {
      title: "Leverage your video library",
      description: "Every video you’ve already made can reach new audiences on MSN",
    },
    {
      title: "No cost, no extra work",
      description: "We handle sharing your existing videos automatically",
    },
  ];

  return (
    <div
      ref={ref}
      className={`${
        isVisible ? "" : ""
      } bg-white py-20 lg:py-32 px-4 xxs:px-8 xs:px-10 sm:px-10 md:px-10 lg:px-12 xl:px-12 4xl:px-16`}
    >
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-12">
          {/* Left Section */}
          <div className="flex-1 flex flex-col gap-[27px] max-w-[702px]">
            {/* Numbered Badge */}
            <div className="bg-gradient-to-b from-[#3b82f6] to-[#2563eb] rounded-[100px] w-[77px] h-[50px] flex items-center justify-center">
              <p className="text-[32px] font-semibold text-white">01</p>
            </div>

            {/* Main Heading */}
            <h1 className="text-5xl xxs:text-[55px] lg:text-[80px] 4xl:text-[80px] font-normal text-black leading-[106px] enfinity-header-font" style={{ lineHeight: "1.2" }}>
              <span>Turn your </span>
              <span className="xl:block">existing videos{" "}</span>
              <span className="text-[#3b82f6]">to 
              new revenue</span>
            </h1>
      
            {/* Description */}
            <p className="text-xl xxs:text-[1rem] lg:text-[24px] font-normal text-black leading-[34px] enfinity-subtext-font">
            Your existing videos can start earning on MSN as well. Use the same content to unlock new opportunities and reach a wider audience. Some creators even earn more on MSN than on other platforms.
            </p>

            {/* Features List */}
            <div className="flex flex-col gap-[30px] max-w-[680px]">
              {features.map((feature, index) => (
                <div key={index} className="flex gap-[15px] items-start">
                  {/* Check Icon */}
                  <div className="bg-[#3b82f6] rounded-[10px] w-8 h-8 flex items-center justify-center flex-shrink-0">
                    <Check className="w-5 h-5 text-white" strokeWidth={2} />
                  </div>

                  {/* Feature Content */}
                  <div className="flex flex-col gap-[10px]">
                    <p className="text-[24px] font-medium text-black leading-[35px] enfinity-header-font">
                      {feature.title}
                    </p>
                    <p className="text-[18px] xxs:text-[1rem] lg:text-lg 4xl:text-[19px] font-normal text-black leading-normal enfinity-subtext-font">
                      {feature.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right Section - Image */}
          <div className="w-full lg:w-[400px] xl:w-[450px] 1xl:w-[500px] 2xl:w-[514px] h-fit my-4 lg:pb-0 xxs:pb-48">
            <img
              src="https://cdn-vvv-e9hucnd2c4dye2ek.z01.azurefd.net/assets/enfinity/boost-card.png"
              alt="Boost Card"
              className="w-full h-full object-contain"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

